// @ts-nocheck
export function getRelationTrackSiteId(): string | null {
  if (typeof UnameIT === "object") {
    return UnameIT.getVisitorId()
  }
  return null
}
